var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3499",
    "data-name": "Group 3499",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.289,
    height: 18.309,
    viewBox: "0 0 19.289 18.309",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_11146",
    "data-name": "Path 11146",
    d: "M1.475,7.673h16.34v9.162H1.475ZM14.787,4.1V2.787h3.029V6.2H1.475V2.787H4.6V4.1H6.069V2.787h7.243V4.1ZM13.313,0V1.313H6.069V0H4.6V1.313H0v17H19.289v-17h-4.5V0Z",
    fill: "#77868d"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1944",
    "data-name": "Rectangle 1944",
    width: 1.458,
    height: 1.474,
    transform: "translate(7.762 8.728)",
    fill: "#77868d"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1945",
    "data-name": "Rectangle 1945",
    width: 1.458,
    height: 1.474,
    transform: "translate(5.27 11.511)",
    fill: "#77868d"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1946",
    "data-name": "Rectangle 1946",
    width: 1.458,
    height: 1.474,
    transform: "translate(7.762 11.511)",
    fill: "#77868d"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1947",
    "data-name": "Rectangle 1947",
    width: 1.458,
    height: 1.474,
    transform: "translate(2.771 11.511)",
    fill: "#77868d"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1948",
    "data-name": "Rectangle 1948",
    width: 1.458,
    height: 1.474,
    transform: "translate(5.27 14.306)",
    fill: "#77868d"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1949",
    "data-name": "Rectangle 1949",
    width: 1.458,
    height: 1.474,
    transform: "translate(7.762 14.306)",
    fill: "#77868d"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1950",
    "data-name": "Rectangle 1950",
    width: 1.458,
    height: 1.474,
    transform: "translate(2.771 14.306)",
    fill: "#77868d"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1951",
    "data-name": "Rectangle 1951",
    width: 1.458,
    height: 1.474,
    transform: "translate(12.775 8.728)",
    fill: "#77868d"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1952",
    "data-name": "Rectangle 1952",
    width: 1.458,
    height: 1.474,
    transform: "translate(15.266 8.728)",
    fill: "#77868d"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1953",
    "data-name": "Rectangle 1953",
    width: 1.451,
    height: 1.474,
    transform: "translate(10.276 8.728)",
    fill: "#77868d"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1954",
    "data-name": "Rectangle 1954",
    width: 1.458,
    height: 1.474,
    transform: "translate(12.775 11.511)",
    fill: "#77868d"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1955",
    "data-name": "Rectangle 1955",
    width: 1.458,
    height: 1.474,
    transform: "translate(15.266 11.511)",
    fill: "#77868d"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1956",
    "data-name": "Rectangle 1956",
    width: 1.451,
    height: 1.474,
    transform: "translate(10.276 11.511)",
    fill: "#77868d"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1957",
    "data-name": "Rectangle 1957",
    width: 1.451,
    height: 1.474,
    transform: "translate(10.276 14.306)",
    fill: "#77868d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateIcon);
export default __webpack_public_path__ + "static/media/date-icon.4543a826437e879e5149c5165ff399f5.svg";
export { ForwardRef as ReactComponent };